// extracted by mini-css-extract-plugin
export default {"drawerTitle":"style_drawerTitle__u9sje","drawerText":"style_drawerText__HpYxG","drawerInput":"style_drawerInput__39bLI"};